import * as React from "react";

import {
  Loading,
  useJoinForm,
  useLoginForm,
  useOneTimePasswordUserExperienceFirstStepSendCode,
  useOneTimePasswordUserExperienceSecondStepVerifyCode,
} from "../../Common";
import { usePdpWishlistUserExperience } from "../providers";

export const AppLoading: React.FunctionComponent = () => {
  const { isLoading: isJoinFormLoading } = useJoinForm();
  const { isLoading: isLoginFormLoading } = useLoginForm();
  const { isLoading: isOneTimePasswordSendCodeLoading } =
    useOneTimePasswordUserExperienceFirstStepSendCode();
  const { isLoading: isOneTimePasswordVerifyCodeLoading } =
    useOneTimePasswordUserExperienceSecondStepVerifyCode();

  const { isLoading: isPdpWishlistLoading } = usePdpWishlistUserExperience();

  const isLoading = React.useMemo(() => {
    return (
      isJoinFormLoading ||
      isLoginFormLoading ||
      isOneTimePasswordSendCodeLoading ||
      isOneTimePasswordVerifyCodeLoading ||
      isPdpWishlistLoading
    );
  }, [
    isJoinFormLoading,
    isLoginFormLoading,
    isOneTimePasswordSendCodeLoading,
    isOneTimePasswordVerifyCodeLoading,
    isPdpWishlistLoading,
  ]);

  if (!isLoading) {
    return null;
  }

  return <Loading />;
};
